export default "__VITE_ASSET__CJyKgZ5N__"